import { MEDICAL_INSURENCE_PARTICULAR } from "./constants";

export function filter(state) {
  return state.filter;
}

export function tenant(state) {
  return state.filter.tenant;
}

export function location(state) {
  return state.filter.location;
}

export function attendance(state) {
  return state.filter.attendance;
}

export function professional(state) {
  return state.filter.professional;
}

export function specialty(state) {
  return state.filter.specialty;
}

export function date(state) {
  return state.filter.date;
}

export function medicalInsurance(state) {
  return state.filter.medicalInsurance;
}

export function medicalInsuranceObj(state) {
  if (state.filter.medicalInsurance)
    return state.medicalInsurances.find(
      (m) => m.codigo == state.filter.medicalInsurance
    );

  return MEDICAL_INSURENCE_PARTICULAR;
}

export function selected(state) {
  return state.selected;
}

export function bookingStep(state) {
  return state.bookingStep;
}

export function attendances(state) {
  return state.attendances;
}

export function medicalInsurances(state) {
  return state.medicalInsurances;
}

export function fullDaysOrNotAvaible(state) {
  return state.fullDaysOrNotAvaible;
}

export function specialties(state) {
  return state.specialties;
}

export function professionals(state) {
  return state.professionals;
}

export function company(state) {
  return state.company;
}

export function companies(state) {
  return state.companies;
}

export function isTelemedicina (state) {
  return state.filter && (state.filter.attendance === 'telemedicina' || state.filter.attendance === 'online');
}


export function isParticular(state) {
  return state.filter.paymentForm == "particular";
}

export function professionalsByTenant(state, getters) {
  const professionals = state.professionals;

  if (!professionals || professionals.length == 0) return null;

  const tenant = getters.tenant;

  const ifPresencialOnlyWithDetail = () =>
    getters.isTelemedicina
      ? professionals
      : professionals?.filter((p) => p.tenant.hasTenantDetail === true);

  if (tenant)
    return ifPresencialOnlyWithDetail().filter(
      (p) => p.tenant.codigo == tenant
    );

  return ifPresencialOnlyWithDetail();
}

export function tenantsDistinct(state, getters) {
  const attendances = getters.attendances;

  if (!attendances || Object.keys(attendances).length == 0) return [];

  const uniques = Object.keys(attendances)
    .sort()
    .reduce(function (result, key) {
      const att = attendances[key];
      const uniques = att.filter(
        (a, index, self) =>
          index === self.findIndex((t) => t.codigo === a.codigo)
      );
      result[key] = uniques;
      return result;
    }, {});

  return uniques;
}
